<!------------ START TEMPLATE ------------>
<template>
  <vs-card>
    <div slot="header">
      <h3>
        Mensagens
        <br style="clear: both" />
      </h3>
    </div>
    <br class="break" />

    <div class="vx-col w-full mb-2">
      <span>Assunto</span>

      <vs-input
        class="w-full"
        name="assunto"
        v-model="formDadosNotas.assunto"
        v-validate="{ required: true, min: 4 }"
      />
    </div>
    <br class="break" />

    <div class="w-full">
      <span>Mensagem</span>
      <vue-editor
        :editor-toolbar="customToolbar"
        v-model="formDadosNotas.mensagem"
      ></vue-editor>
    </div>
    <br class="break" />

    <div class="w-full">
      <DragAndDropUpload
        texto="Arraste seus arquivos aqui ou clique abaixo para fazer o upload"
        :extensoesPermitidas="'png-jpg-jpeg-gif-pdf'"
        :iconUpload="'icon-paperclip'"
        @files="handleFiles"
      />
    </div>

    <GenericMultiplePreviews
      :files="listArquivosToUpload"
      :onDeletePreview="onDeletePreview"
    />

    <br class="break" />
    <div class="row mt-5 text-right">
      <div class="">
        <vs-button
          color="success"
          class="mr-3 mb-2"
          @click="onSubmitPropostaNota"
          >Salvar
        </vs-button>
      </div>
    </div>
    <br class="break" />

    <ListHistoricoMensagensVistoria :keyForm="keyForm" />
  </vs-card>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import customToolbar from './../../components/editor/config';
import DragAndDropUpload from './../../components/upload-drag-and-drop/UploadDragAndDrop.vue';
import { VueEditor } from 'vue2-editor';
import services from '../../services';
import ListHistoricoMensagensVistoria from './../lists/ListHistoricoMensagensVistoria';
import notify from '../../utils/notify';
import GenericMultiplePreviews from '../../components/generic/GenericMultiplePreviews.vue';

export default {
  name: 'FormMensagemVistoria',
  props: {
    idEmpresa: {
      type: Number,
    },
  },
  data() {
    return {
      formDadosNotas: {
        assunto: '',
        mensagem: '',
        files: [],
      },
      customToolbar,
      listArquivosToUpload: [],
      keyForm: 0,
    };
  },
  methods: {
    async onSubmitPropostaNota() {
      const { formDadosNotas } = this;
      const { assunto, mensagem, files } = formDadosNotas;
      const idProposta = this.$route.params.idCotacao;
      const idEmpresa = this.idEmpresa;
      let uploadedFiles = [];

      if (!this.isValidFields(assunto, mensagem, idProposta, idEmpresa)) {
        const errorMessage = `Por favor, preencha todos os campos obrigatórios:
      ${!assunto ? '- Assunto\n' : ''}${!mensagem ? '- Mensagem\n' : ''}`;

        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: errorMessage.trim(),
          color: 'danger',
        });
        return;
      }

      try {
        this.$vs.loading();
        const model = 'propostas-notas';
        const action = `PropostasNotas/${idEmpresa}`;

        if (files.length > 0) {
          uploadedFiles = await this.uploadAWS();
        }

        await services.post(model, action, {
          idProposta,
          assunto,
          mensagem,
          uploadedFiles,
        });
        this.updateListMessages();
        this.$vs.notify({
          position: 'top-center',
          title: 'Sucesso',
          text: 'Sua mensagem foi enviada.',
          color: 'success',
        });
        this.clearFormPropostaNota();
      } catch {
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: 'Não foi possível salvar a mensagem da vistoria.',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    clearFormPropostaNota() {
      const { formDadosNotas } = this;

      formDadosNotas.assunto = '';
      formDadosNotas.mensagem = '';
      formDadosNotas.files = [];
      this.listArquivosToUpload = [];
    },
    isValidFields(assunto, mensagem, idProposta, idEmpresa) {
      const allFieldsFilled = assunto && mensagem && idProposta && idEmpresa;
      return allFieldsFilled;
    },
    async handleFiles(files) {
      if (!files.length) {
        return;
      }

      files.forEach((file) => {
        const { name, type } = file;
        const legenda = this.getNomeArquivoSemExtensao(name);
        const url = URL.createObjectURL(file);

        this.listArquivosToUpload.push({
          legenda,
          url,
          name,
          type,
          date: new Date(),
          file,
        });

        this.formDadosNotas.files.push(file);
      });

      await this.uploadAWS();
    },
    async uploadAWS() {
      try {
        const formDataSend = new FormData();

        this.formDadosNotas.files.forEach((file) => {
          formDataSend.append('files', file);
        });

        this.$vs.loading();
        const idPropostaRoute = this.$route.params.idCotacao;
        const { uploadedFiles } = await services.uploadAll(
          'upload-multi',
          'PropostasNotas/' + idPropostaRoute,
          formDataSend,
        );
        return uploadedFiles;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    getNomeArquivoSemExtensao(nomeArquivo) {
      const ultimoPontoIndex = nomeArquivo.lastIndexOf('.');

      if (ultimoPontoIndex !== -1) {
        return nomeArquivo.substring(0, ultimoPontoIndex);
      }

      return nomeArquivo;
    },
    onDeletePreview(index) {
      this.listArquivosToUpload.splice(index, 1);
    },
    updateListMessages() {
      this.keyForm += 1;
    },
  },
  mounted() {
    this.$on('update-list-messages', () => {
      this.getAllMessages();
    });
  },

  components: {
    DragAndDropUpload,
    VueEditor,
    ListHistoricoMensagensVistoria,
    GenericMultiplePreviews,
  },
};
</script>
<!------------ END SCRIPT ------------>
